<div class="container">
    <div *ngIf="receipt" id="printArea" class="print-area">
        <div>
            <div [innerHTML]="receipt.Base64"></div>
        </div>
    </div>

    <div class="to-center">
        <button class="receipt-button" (click)="print()">
            <fa-icon [icon]="printIcon"></fa-icon> {{ 'Buttons.print' | translate }}
        </button>
        <button class="receipt-button" (click)="back()">
            <fa-icon [icon]="backIcon"></fa-icon> {{ 'Buttons.goBack' | translate }}
        </button>
    </div>
    <div>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
            <div class="send-mail-form center">
                <div>
                    <input class="send-mail-input" type="text" (keyup)="onKeyUp($event)" formControlName="email"
                        autocomplete="on" [translate]="'labels.emeil'" placeholder="{{'label.email' | translate }}">
                    <div class="send-mail-error-message" *ngIf="emailWrongFormat" [translate]="'Messages.wrongEmail'">
                    </div>
                </div>
                <div>
                    <button class="send-mail-button">
                        <fa-icon [icon]="sendMailIcon"></fa-icon> <span style="margin-left: 10px ;"
                            [translate]="'Buttons.sendToEmail'"></span>
                    </button>
                </div>
            </div>
        </form>

        <div class="send-email-success-message" *ngIf="userEmail">
            <ng-container *ngIf="emailSuccess; else elseBlock">
                <span [translate]="'Messages.sendedToEmail'" [translateParams]="{userEmail: [userEmail]}"></span>
            </ng-container>
            <ng-template #elseBlock [translate]="'Messages.tryLater'">
            </ng-template>
        </div>
    </div>
</div>
<app-loading *ngIf=" !receipt"></app-loading>